import { render, staticRenderFns } from "./AddBulletin.vue?vue&type=template&id=68af1542&scoped=true&"
import script from "./AddBulletin.vue?vue&type=script&lang=js&"
export * from "./AddBulletin.vue?vue&type=script&lang=js&"
import style0 from "./AddBulletin.vue?vue&type=style&index=0&id=68af1542&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68af1542",
  null
  
)

export default component.exports